var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import Slider from '@mui/material/Slider';
import './questionnaireSlider.css';
var QuestionnaireSlider = function (_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, label = _a.label, _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 10 : _c, _d = _a.choices, choices = _d === void 0 ? [] : _d;
    // Helper function to check storage on initial render
    var getInitialLastValue = function () {
        if (typeof window !== 'undefined') {
            try {
                var stored = sessionStorage.getItem("slider_prev_".concat(name));
                if (stored !== null && !isNaN(Number(stored))) {
                    return Number(stored);
                }
            }
            catch (e) {
                console.warn("Could not access sessionStorage");
            }
        }
        return min;
    };
    var lastValue = useRef(getInitialLastValue());
    // update ref and sessionStorage
    if (value !== 'Prefer not to say') {
        var numValue = Number(value);
        if (!isNaN(numValue)) {
            lastValue.current = numValue;
            if (typeof window !== 'undefined') {
                try {
                    sessionStorage.setItem("slider_prev_".concat(name), String(numValue));
                }
                catch (e) {
                }
            }
        }
    }
    var isPreferNotToSay = value === 'Prefer not to say';
    var parsedValue = Number(value);
    var sliderValue = isPreferNotToSay ? lastValue.current : (!isNaN(parsedValue) ? parsedValue : min);
    return (_jsxs("div", __assign({ className: "slider-container py-4" }, { children: [_jsx(Slider, { name: name, value: sliderValue, disabled: isPreferNotToSay, onChange: function (event, newValue) {
                    onChange(name, String(newValue));
                }, "aria-label": label, valueLabelDisplay: "off", step: 1, marks: choices.map(function (choice, idx) { return ({
                    value: idx,
                    label: idx.toString()
                }); }), min: min, max: max, slotProps: {
                    track: {
                        style: {
                            backgroundColor: isPreferNotToSay ? '#d1d5db' : '#6c63ff',
                            border: 'none',
                            height: 8,
                            borderRadius: 4
                        }
                    },
                    thumb: {
                        style: {
                            height: 24,
                            width: 24,
                            backgroundColor: '#fff',
                            border: isPreferNotToSay ? '2px solid #d1d5db' : '2px solid #6c63ff'
                        }
                    },
                    mark: {
                        style: {
                            backgroundColor: '#bfbfbf',
                            height: 8,
                            width: 2
                        }
                    },
                    markLabel: {
                        style: {
                            fontSize: '0.875rem',
                            color: isPreferNotToSay ? '#9ca3af' : '#6b7280',
                            fontWeight: 500
                        }
                    }
                } }), _jsxs("div", __assign({ className: "slider-labels text-sm text-gray-600 mb-4" }, { children: [_jsx("span", __assign({ className: "font-medium ".concat(isPreferNotToSay ? 'text-gray-400' : '') }, { children: "Not at all" })), _jsx("span", __assign({ className: "font-medium ".concat(isPreferNotToSay ? 'text-gray-400' : '') }, { children: "To a very great extent" }))] })), _jsxs("div", __assign({ className: "flex items-center mt-6 pt-4 border-t border-gray-200" }, { children: [_jsx("input", { type: "checkbox", id: "".concat(name, "-prefer-not"), checked: isPreferNotToSay, onChange: function (e) {
                            if (e.target.checked) {
                                onChange(name, 'Prefer not to say');
                            }
                            else {
                                onChange(name, String(lastValue.current));
                            }
                        }, className: "w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer" }), _jsx("label", __assign({ htmlFor: "".concat(name, "-prefer-not"), className: "ml-2 text-sm font-medium text-gray-700 cursor-pointer select-none" }, { children: "Prefer not to say" }))] }))] })));
};
export default QuestionnaireSlider;
